











import Vue, { PropType } from 'vue';

import * as PDFJS from 'pdfjs-dist/legacy/build/pdf';

import { PDFDocumentLoadingTask } from 'pdfjs-dist';
import {
  GetDocumentParameters,
  PDFDocumentProxy
} from 'pdfjs-dist/types/src/display/api';

import 'pdfjs-dist/web/pdf_viewer.css';

import PDF from './PDF.vue';

// install pdf worker from cdn distrubition
PDFJS.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@2.16.105/legacy/build/pdf.worker.min.js`;

interface Options extends InstanceType<typeof Vue> {
  $refs: {
    container: HTMLDivElement;
    loadingLayer: HTMLDivElement;
  };
}
type PDFSource = GetDocumentParameters;

export default Vue.extend<Options>({ functional: false }).extend({
  name: 'PDFViewer',

  components: {
    PDF
  },

  props: {
    source: {
      type: [String, Object] as PropType<PDFSource>
    },

    page: {
      type: Number,
      default: 1
    },

    showAllPages: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      pdf: null as PDFDocumentLoadingTask | null,

      pdfDocument: null as PDFDocumentProxy | null,
      pages: 0
    };
  },

  watch: {
    source: {
      handler(source: PDFSource) {
        this.loadPDF(source);
      }
    }
  },

  mounted() {
    if (!this.source) {
      throw Error('No source provided');
    }

    this.loadPDF(this.source);
  },

  methods: {
    loadPDF(source: PDFSource) {
      this.$emit('startLoading');
      if (this.pdfDocument) {
        this.pdfDocument.destroy();
      }

      const loadingTask = PDFJS.getDocument(source);
      // maybe add events as props to load in

      loadingTask.promise
        .then(
          document => {
            this.pdfDocument = document;

            this.pdf = document.loadingTask;
            this.pages = document.numPages;
          },
          error => {
            // PDF loading error
            this.$emit('error', error);
          }
        )
        .finally(() => {
          this.$emit('endLoading');
        });
    },

    /**
     * Return the number of pages pdf file contains
     * @public
     *
     */
    getPages(): number {
      return this.pages;
    }
  }
});
